import type { MessageDescriptor } from "@lingui/core";
import { defineMessage as dm } from "@lingui/core/macro";

export const commandPaletteLabels: Record<string, MessageDescriptor> = {
  searchPlaceholder: dm`Search, or type / for commands...`,
  commandPlaceholder: dm`Type a command...`,
  noResults: dm`No results found`,
  noCommands: dm`No matching commands`,
  allTypes: dm`All types`,
  filterTypesPlaceholder: dm`Filter type...`,
  removeFilter: dm`Remove filter`,
  sameKeyIsOr: dm`Same key repeated = OR`,
  differentKeysAreAnd: dm`Different keys = AND`,
  spaceValidatesFilter: dm`Space validates a filter`,
  backspaceRemovesLastFilter: dm`Backspace removes the last filter`,
  navigateHint: dm`navigate`,
  openHint: dm`open`,
  clearHint: dm`clear`,
  resultsCount: dm`{count} results out of {total}`,
  textContains: dm`text contains "{text}"`,
  orConnector: dm`or`,
  andConnector: dm`AND`,
};
